<!-------------------------------------------------------------------------------------------->
<!-- INITIALIZING: During initializing the media is being configured and attempting to load -->
<!-------------------------------------------------------------------------------------------->

<!-- During Initialize display a query loading bar as there is nothing to show -->
@if (mediaRepository.initializing()) {
  <mat-progress-bar class="loader disable-pointer" mode="query" />
}

<!-------------------------------------------------------------------------------------------->
<!-- INITIALIZING ERROR: During initializing if an error occurs the component will never    -->
<!-- reach the initialized state                                                            -->
<!-------------------------------------------------------------------------------------------->

<!-- If an error occurs during initialization, then a specific error duplication is shown. -->
@if (mediaRepository.initializingError()) {
  <div
    class="container"
    [style.aspectRatio]="mediaRepository.aspectRatio()"
    [class.limit-portrait-width-on-desktop]="mediaRepository.limitPortraitWidthOnDesktop()"
  >
    @if (mediaRepository.error()) {
      <div class="error">
        <div class="error-content">
          <app-fa-icon class="error-icon" [config]="mediaRepository.errorIcon()" />
          @if (mediaRepository.errorReason()) {
            <div>{{ mediaRepository.errorReason() }}</div>
          }
        </div>
      </div>
    }
  </div>
}

<!-------------------------------------------------------------------------------------------->
<!-- INITIALIZED: The media has been configured and managed to boot up.                     -->
<!-------------------------------------------------------------------------------------------->

<!-- Initialized -->
@if (mediaRepository.initialized()) {
  <div
    class="container"
    [style.aspectRatio]="mediaRepository.aspectRatio()"
    [class.limit-portrait-width-on-desktop]="mediaRepository.limitPortraitWidthOnDesktop()"
  >
    <!-- Once details become available, the poster of the media can be displayed -->
    @if (mediaRepository.hasPoster()) {
      <div class="poster disable-pointer" [style.backgroundImage]="mediaRepository.poster()"></div>
    }
    <div
      class="provider-container"
      [class.disable-pointer]="mediaRepository.interactionDisabled()"
      appDomIntersectionObserver
      (isIntersecting)="isIntersecting($event)"
      [isContinuous]="true"
    >
      <!-- Once all dependencies are met, the system becomes active as displays the correct player -->
      @if (mediaRepository.shouldRenderYouTube()) {
        <app-media-youtube class="provider" [class.provider-ready]="mediaRepository.isReady()" />
      }
      @if (mediaRepository.shouldRenderVimeo()) {
        <app-media-vimeo class="provider" [class.provider-ready]="mediaRepository.isReady()" />
      }
      @if (mediaRepository.shouldRenderVideo()) {
        <app-media-native-video class="provider" [class.provider-ready]="mediaRepository.isReady()" />
      }
      @if (mediaRepository.shouldRenderAudio()) {
        <app-media-native-audio class="provider" [class.provider-ready]="mediaRepository.isReady()" />
      }
      <!-- Contains overlaid UI for play button, and play and pause state animations -->
      @if (mediaRepository.displayUIOverlay()) {
        <app-media-ui class="ui disable-pointer" />
      }
    </div>
    <!-- Errors can occur for any reason -->
    @if (mediaRepository.error()) {
      <div class="error">
        <div class="error-content">
          <app-fa-icon class="error-icon" [config]="mediaRepository.errorIcon()" />
          @if (mediaRepository.errorReason()) {
            <div>{{ mediaRepository.errorReason() }}</div>
          }
        </div>
      </div>
    }
  </div>
}
